import { Accessibility, ActivityIcon, ArchiveIcon, AlertCircle, AlertTriangleIcon, AnchorIcon, AppleIcon, ArrowBigLeftIcon, ArrowBigRightIcon, ArrowBigUpIcon, ArrowDownIcon, ArrowLeftFromLineIcon, ArrowLeftIcon, ArrowRightIcon, ArrowRightLeftIcon, ArrowUpDownIcon, ArrowUpIcon, ArrowUpRightFromSquareIcon, AtSignIcon, BadgeCheckIcon, BadgeIcon, BadgeInfoIcon, BaggageClaimIcon, BanIcon, BatteryFullIcon, BellIcon, BellOffIcon, BellRingIcon, BookmarkIcon, BookOpenIcon, BookTextIcon, BotMessageSquare, BriefcaseBusinessIcon, BriefcaseMedicalIcon, Building, Building2, CalculatorIcon, CakeIcon, CalendarClockIcon, Camera, Clock2Icon, ClockCheckIcon, CalendarDaysIcon, CalendarIcon, CalendarRange, ChartNoAxesGanttIcon, Check, CloudUpload, ChevronDownIcon, ChevronFirstIcon, ChevronLastIcon, ChevronLeft, ChevronRight, ChevronUpIcon, ChevronsDownUpIcon, ChevronsLeft, ChevronsRight, ChevronsUpDownIcon, CircleArrowRight, CircleCheckBigIcon, CircleCheckIcon, CircleDashed, CircleDashedIcon, CircleDollarSignIcon, CircleDotDashedIcon, CircleDotIcon, CircleFadingPlusIcon, CircleHelpIcon, CircleIcon, CircleOffIcon, CirclePauseIcon, CirclePlay, CircleSlash2, CircleStop, Play, CircleUserRoundIcon, CircleXIcon, CircuitBoardIcon, ClipboardListIcon, ClipboardXIcon, Code2Icon, CommandIcon, ConstructionIcon, ContactRound, ComponentIcon, CopyIcon, CornerDownLeftIcon, CpuIcon, DatabaseBackup, DatabaseZapIcon, DoorClosedIcon, DotIcon, Download, DropletIcon, EditIcon, EllipsisIcon, Expand, ExternalLinkIcon, Eye, EyeOff, FileCheckIcon, FileClock, FileIcon, FilePenIcon, FilePenLineIcon, FastForwardIcon, FileSpreadsheet, FileTextIcon, FileUpIcon, FileXIcon, FlagTriangleRightIcon, FolderIcon, FolderInputIcon, FolderKeyIcon, FolderOpenIcon, FolderTreeIcon, FunctionSquareIcon, GaugeIcon, Gem, Grid2x2, Gift, GitCompareIcon, GripVerticalIcon, GroupIcon, Hammer, HandshakeIcon, HardDriveIcon, HashIcon, HeartMinusIcon, HeartPulseIcon, HelpCircleIcon, HistoryIcon, HomeIcon, IdCardIcon, ImageIcon, ImageUpIcon, ImportIcon, InfoIcon, IterationCw, KeyRoundIcon, LandPlotIcon, LaptopIcon, LayersIcon, LayoutGridIcon, Link2Icon, Link2OffIcon, LinkIcon, ListCheckIcon, ListFilterIcon, ListIcon, ListOrderedIcon, ListPlusIcon, ListXIcon, Loader2Icon, LoaderCircleIcon, LoaderIcon, LogInIcon, LogOutIcon, Mail, MapPin, MapPinned, MemoryStickIcon, MenuIcon, MessageCircleIcon, MessageCirclePlus, MessageSquare, MinusIcon, MonitorIcon, MonitorSmartphoneIcon, MoreHorizontalIcon, MoreVerticalIcon, MouseIcon, MoveDownRightIcon, MoveRightIcon, MoveUpRightIcon, NetworkIcon, OptionIcon, PackageIcon, PackageMinusIcon, PackageOpen, PackagePlusIcon, PanelLeftCloseIcon, PanelLeftOpenIcon, PanelRightCloseIcon, Paperclip, PartyPopper, PencilIcon, Phone, PlaneLandingIcon, PlaneTakeoffIcon, PlusCircle, PlusIcon, PointerIcon, PrinterIcon, QrCodeIcon, RadioIcon, ReceiptIcon, ReceiptTextIcon, RecycleIcon, RedoDotIcon, RefreshCcwDotIcon, RefreshCwIcon, Repeat2Icon, RocketIcon, RouterIcon, Rows2Icon, SatelliteDishIcon, SaveIcon, ScanBarcodeIcon, SearchIcon, SearchSlashIcon, SearchXIcon, SendHorizontalIcon, SendIcon, ServerIcon, Settings2Icon, SettingsIcon as SettingsLucideIcon, Share2, Split, ShieldCheckIcon, ShieldEllipsisIcon, ShieldHalfIcon, ShieldIcon, ShieldOffIcon, ShieldXIcon, ShoppingCart, Shrink, SlidersHorizontal, SmartphoneIcon, Square, SquareArrowOutUpRightIcon, SquareArrowRightEnterIcon, SquareArrowRightExitIcon, SquareArrowRightIcon, SquareArrowUpRightIcon, SquareAsterisk, SquareCheckBig, SquareCodeIcon, SquareDot, SquaresExclude, SquareUser, SquarePenIcon, Sparkles, StampIcon, StarIcon, StickyNoteIcon, StretchHorizontalIcon, Table2Icon, TabletSmartphoneIcon, TagIcon, ThumbsUpIcon, TimerOffIcon, Trash2Icon, TrendingDownIcon, TrendingUpIcon, TriangleAlertIcon, Truck, User2Icon, UserRoundCheckIcon, UserRoundCogIcon, UserRoundIcon, UserRoundMinusIcon, UserRoundPlusIcon, UserRoundSearchIcon, UserRoundXIcon, UsersRoundIcon, Video, ViewIcon, WaypointsIcon, WrenchIcon, XIcon, XOctagonIcon } from 'lucide-react';
import { ProductLogoSmallContracts, ProductLogoSmallIDs, ProductLogoSmallPeople, ProductLogoSmallPlaces, ProductLogoSmallSoftware } from '../Logo';
import { GoogleIcon, MicrosoftIcon } from './BrandIcons';
import { AccountIcon, AppsIcon, ArrowLeftToLineIcon, ArrowRightFromLineIcon, ArrowRightToLineIcon, BoardMemberIcon, CollaboratorIcon, ContractorIcon, DevicesIcon, IncorrectRoleIcon, JobLevelIcon, NoLogoIcon, OperationTaskIcon, OrganizationIcon, OriginalAltKeyWindowsIcon, OriginalCategoryPermissionIcon, OriginalManagerIcon, OriginalPlacementCheckIcon, OriginalRoleIcon, OsAndroidIcon, OsChromeIcon, OsLinuxIcon, OsMacosIcon, OsOthersIcon, OsWindowsIcon, PenLineIcon, PeopleIcon, PortAudioIcon, PortDisplayPortIcon, PortDviIcon, PortHdmiIcon, PortLanIcon, PortMiniDisplayPortIcon, PortThunderboltIcon, PortUsbMicroBIcon, PortUsbMiniIcon, PortUsbTypeAIcon, PortUsbTypeBIcon, PortUsbTypeCIcon, PortVgaIcon, ProductIcon, RoleIcon, SettingsIcon, StatusIcon, WorkArrangementIcon } from './ForceIcons';
import { OriginalIdIcon } from './ForceIcons/OriginalIdIcon';
import { OriginalTableOfContentIcon } from './ForceIcons/OriginalTableOfContentIcon';
import { LogicalAndIcon, LogicalOrIcon } from './LogicalIcons';
import { MaterialContractIcon, MaterialInventoryIcon, MaterialQuickReferenceAll } from './MaterialIcons';
export const IconMap = {
  Accessibility: Accessibility,
  AccountIcon: AccountIcon,
  ArchiveIcon: ArchiveIcon,
  ActivityIcon: ActivityIcon,
  AlertCircle: AlertCircle,
  AlertTriangleIcon: AlertTriangleIcon,
  AppleIcon: AppleIcon,
  AppsIcon: AppsIcon,
  AnchorIcon: AnchorIcon,
  ArrowBigLeftIcon: ArrowBigLeftIcon,
  ArrowBigRightIcon: ArrowBigRightIcon,
  ArrowBigUpIcon: ArrowBigUpIcon,
  ArrowDownIcon: ArrowDownIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ArrowRightIcon: ArrowRightIcon,
  ArrowRightLeftIcon: ArrowRightLeftIcon,
  ArrowLeftFromLineIcon: ArrowLeftFromLineIcon,
  ArrowLeftToLineIcon: ArrowLeftToLineIcon,
  ArrowRightFromLineIcon: ArrowRightFromLineIcon,
  ArrowRightToLineIcon: ArrowRightToLineIcon,
  ArrowUpDownIcon: ArrowUpDownIcon,
  ArrowUpIcon: ArrowUpIcon,
  ArrowUpRightFromSquareIcon: ArrowUpRightFromSquareIcon,
  AtSignIcon: AtSignIcon,
  BadgeCheckIcon: BadgeCheckIcon,
  BadgeIcon: BadgeIcon,
  BadgeInfoIcon: BadgeInfoIcon,
  BaggageClaimIcon: BaggageClaimIcon,
  BanIcon: BanIcon,
  BatteryFullIcon: BatteryFullIcon,
  BoardMemberIcon: BoardMemberIcon,
  BellIcon: BellIcon,
  BellOffIcon: BellOffIcon,
  BellRingIcon: BellRingIcon,
  BookmarkIcon: BookmarkIcon,
  BookOpenIcon: BookOpenIcon,
  BookTextIcon: BookTextIcon,
  BriefcaseBusinessIcon: BriefcaseBusinessIcon,
  BriefcaseMedicalIcon: BriefcaseMedicalIcon,
  BotMessageSquareIcon: BotMessageSquare,
  Building: Building,
  Building2: Building2,
  CalculatorIcon: CalculatorIcon,
  CakeIcon: CakeIcon,
  CalendarClockIcon: CalendarClockIcon,
  Clock2Icon: Clock2Icon,
  ClockCheckIcon: ClockCheckIcon,
  CalendarDaysIcon: CalendarDaysIcon,
  CalendarIcon: CalendarIcon,
  CalendarRange: CalendarRange,
  Camera: Camera,
  ChartNoAxesGanttIcon: ChartNoAxesGanttIcon,
  Check: Check,
  CloudUpload: CloudUpload,
  Sparkles: Sparkles,
  ChevronDownIcon: ChevronDownIcon,
  ChevronFirstIcon: ChevronFirstIcon,
  ChevronLastIcon: ChevronLastIcon,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  ChevronsDownUpIcon: ChevronsDownUpIcon,
  ChevronsLeft: ChevronsLeft,
  ChevronsRight: ChevronsRight,
  ChevronsUpDownIcon: ChevronsUpDownIcon,
  ChevronUpIcon: ChevronUpIcon,
  CircleArrowRight: CircleArrowRight,
  CircleCheckBigIcon: CircleCheckBigIcon,
  CircleCheckIcon: CircleCheckIcon,
  CircleDashed: CircleDashed,
  CircleDashedIcon: CircleDashedIcon,
  CircleDollarSignIcon: CircleDollarSignIcon,
  CircleDotDashedIcon: CircleDotDashedIcon,
  CircleDotIcon: CircleDotIcon,
  CircleFadingPlusIcon: CircleFadingPlusIcon,
  CircleHelpIcon: CircleHelpIcon,
  CircleIcon: CircleIcon,
  CircleOffIcon: CircleOffIcon,
  CirclePauseIcon: CirclePauseIcon,
  CirclePlay: CirclePlay,
  CircleSlash2: CircleSlash2,
  PlayIcon: Play,
  CircleStop: CircleStop,
  CircleUserRoundIcon: CircleUserRoundIcon,
  CircleXIcon: CircleXIcon,
  CircuitBoardIcon: CircuitBoardIcon,
  ClipboardListIcon: ClipboardListIcon,
  ClipboardXIcon: ClipboardXIcon,
  Code2Icon: Code2Icon,
  CollaboratorIcon: CollaboratorIcon,
  ConstructionIcon: ConstructionIcon,
  ContactRound: ContactRound,
  Contract: MaterialContractIcon,
  ContractProductLogoSmall: ProductLogoSmallContracts,
  ContractorIcon: ContractorIcon,
  ComponentIcon: ComponentIcon,
  IDsProductLogoSmall: ProductLogoSmallIDs,
  PeopleProductLogoSmall: ProductLogoSmallPeople,
  SoftwareProductLogoSmall: ProductLogoSmallSoftware,
  CommandIcon: CommandIcon,
  CopyIcon: CopyIcon,
  CornerDownLeftIcon: CornerDownLeftIcon,
  CpuIcon: CpuIcon,
  DatabaseBackup: DatabaseBackup,
  DatabaseZapIcon: DatabaseZapIcon,
  DevicesIcon: DevicesIcon,
  DoorClosedIcon: DoorClosedIcon,
  DotIcon: DotIcon,
  Download: Download,
  DropletIcon: DropletIcon,
  EditIcon: EditIcon,
  EllipsisIcon: EllipsisIcon,
  Expand: Expand,
  ExternalLinkIcon: ExternalLinkIcon,
  Eye: Eye,
  EyeOff: EyeOff,
  FastForwardIcon: FastForwardIcon,
  FileCheckIcon: FileCheckIcon,
  FileClock: FileClock,
  FileIcon: FileIcon,
  FilePenIcon: FilePenIcon,
  FilePenLineIcon: FilePenLineIcon,
  FileSpreadsheet: FileSpreadsheet,
  FileTextIcon: FileTextIcon,
  FileUpIcon: FileUpIcon,
  FileXIcon: FileXIcon,
  FlagTriangleRightIcon: FlagTriangleRightIcon,
  FolderIcon: FolderIcon,
  FolderInputIcon: FolderInputIcon,
  FolderKeyIcon: FolderKeyIcon,
  FolderOpenIcon: FolderOpenIcon,
  FolderTreeIcon: FolderTreeIcon,
  FunctionSquareIcon: FunctionSquareIcon,
  GaugeIcon: GaugeIcon,
  Gem: Gem,
  Grid2x2: Grid2x2,
  GiftIcon: Gift,
  GitCompareIcon: GitCompareIcon,
  GripVerticalIcon: GripVerticalIcon,
  GoogleIcon: GoogleIcon,
  GroupIcon: GroupIcon,
  Hammer: Hammer,
  HandshakeIcon: HandshakeIcon,
  HardDriveIcon: HardDriveIcon,
  HashIcon: HashIcon,
  HeartMinusIcon: HeartMinusIcon,
  HeartPulseIcon: HeartPulseIcon,
  HelpCircleIcon: HelpCircleIcon,
  HistoryIcon: HistoryIcon,
  HomeIcon: HomeIcon,
  IdCardIcon: IdCardIcon,
  ImageIcon: ImageIcon,
  ImageUpIcon: ImageUpIcon,
  ImportIcon: ImportIcon,
  IncorrectRoleIcon: IncorrectRoleIcon,
  InfoIcon: InfoIcon,
  Inventory: MaterialInventoryIcon,
  IterationCw: IterationCw,
  JobLevelIcon: JobLevelIcon,
  KeyRoundIcon: KeyRoundIcon,
  LandPlotIcon: LandPlotIcon,
  LaptopIcon: LaptopIcon,
  LayersIcon: LayersIcon,
  LayoutGridIcon: LayoutGridIcon,
  Link2Icon: Link2Icon,
  Link2OffIcon: Link2OffIcon,
  LinkIcon: LinkIcon,
  ListCheckIcon: ListCheckIcon,
  ListFilterIcon: ListFilterIcon,
  ListIcon: ListIcon,
  ListOrderedIcon: ListOrderedIcon,
  ListPlusIcon: ListPlusIcon,
  ListXIcon: ListXIcon,
  Loader2Icon: Loader2Icon,
  LoaderCircleIcon: LoaderCircleIcon,
  LoaderIcon: LoaderIcon,
  LogicalAndIcon: LogicalAndIcon,
  LogicalOrIcon: LogicalOrIcon,
  LogInIcon: LogInIcon,
  LogOutIcon: LogOutIcon,
  Mail: Mail,
  MapPin: MapPin,
  MapPinned: MapPinned,
  MemoryStickIcon: MemoryStickIcon,
  MenuIcon: MenuIcon,
  MessageCircleIcon: MessageCircleIcon,
  MessageCirclePlusIcon: MessageCirclePlus,
  MessageSquareIcon: MessageSquare,
  MicrosoftIcon: MicrosoftIcon,
  MinusIcon: MinusIcon,
  MonitorIcon: MonitorIcon,
  MonitorSmartphoneIcon: MonitorSmartphoneIcon,
  MoreHorizontalIcon: MoreHorizontalIcon,
  MoreVerticalIcon: MoreVerticalIcon,
  MouseIcon: MouseIcon,
  MoveDownRightIcon: MoveDownRightIcon,
  MoveRightIcon: MoveRightIcon,
  MoveUpRightIcon: MoveUpRightIcon,
  NetworkIcon: NetworkIcon,
  OptionIcon: OptionIcon,
  NoLogoIcon: NoLogoIcon,
  OperationTaskIcon: OperationTaskIcon,
  OrganizationIcon: OrganizationIcon,
  OriginalAltKeyWindowsIcon: OriginalAltKeyWindowsIcon,
  OriginalCategoryPermissionIcon: OriginalCategoryPermissionIcon,
  OriginalIdIcon: OriginalIdIcon,
  OriginalTableOfContentIcon: OriginalTableOfContentIcon,
  OriginalManagerIcon: OriginalManagerIcon,
  OriginalPlacementCheckIcon: OriginalPlacementCheckIcon,
  OriginalRoleIcon: OriginalRoleIcon,
  OsAndroidIcon: OsAndroidIcon,
  OsChromeIcon: OsChromeIcon,
  OsLinuxIcon: OsLinuxIcon,
  OsMacosIcon: OsMacosIcon,
  OsOthersIcon: OsOthersIcon,
  OsWindowsIcon: OsWindowsIcon,
  Package: PackageIcon,
  PackageMinus: PackageMinusIcon,
  PackageOpen: PackageOpen,
  PackagePlus: PackagePlusIcon,
  PanelLeftCloseIcon: PanelLeftCloseIcon,
  PanelLeftOpenIcon: PanelLeftOpenIcon,
  PanelRightCloseIcon: PanelRightCloseIcon,
  Paperclip: Paperclip,
  PartyPopper: PartyPopper,
  PencilIcon: PencilIcon,
  PenLineIcon: PenLineIcon,
  PeopleIcon: PeopleIcon,
  Phone: Phone,
  PlaneLandingIcon: PlaneLandingIcon,
  PlaneTakeoffIcon: PlaneTakeoffIcon,
  PlusCircle: PlusCircle,
  PlusIcon: PlusIcon,
  PointerIcon: PointerIcon,
  PortAudioIcon: PortAudioIcon,
  PortDisplayPortIcon: PortDisplayPortIcon,
  PortDviIcon: PortDviIcon,
  PortHdmiIcon: PortHdmiIcon,
  PortLanIcon: PortLanIcon,
  PortMiniDisplayPortIcon: PortMiniDisplayPortIcon,
  PortThunderboltIcon: PortThunderboltIcon,
  PortUsbMicroBIcon: PortUsbMicroBIcon,
  PortUsbMiniIcon: PortUsbMiniIcon,
  PortUsbTypeAIcon: PortUsbTypeAIcon,
  PortUsbTypeBIcon: PortUsbTypeBIcon,
  PortUsbTypeCIcon: PortUsbTypeCIcon,
  PortVgaIcon: PortVgaIcon,
  PrinterIcon: PrinterIcon,
  ProductIcon: ProductIcon,
  ProductLogoSmallPlaces: ProductLogoSmallPlaces,
  QrCodeIcon: QrCodeIcon,
  QuickReferenceAll: MaterialQuickReferenceAll,
  RadioIcon: RadioIcon,
  ReceiptIcon: ReceiptIcon,
  ReceiptTextIcon: ReceiptTextIcon,
  RecycleIcon: RecycleIcon,
  RedoDotIcon: RedoDotIcon,
  RefreshCcwDotIcon: RefreshCcwDotIcon,
  RefreshCwIcon: RefreshCwIcon,
  Repeat2Icon: Repeat2Icon,
  RocketIcon: RocketIcon,
  RoleIcon: RoleIcon,
  RouterIcon: RouterIcon,
  Rows2Icon: Rows2Icon,
  SatelliteDishIcon: SatelliteDishIcon,
  SaveIcon: SaveIcon,
  ScanBarcodeIcon: ScanBarcodeIcon,
  SearchIcon: SearchIcon,
  SearchSlashIcon: SearchSlashIcon,
  SearchXIcon: SearchXIcon,
  SendIcon: SendIcon,
  SendHorizontalIcon: SendHorizontalIcon,
  ServerIcon: ServerIcon,
  Settings2Icon: Settings2Icon,
  SettingsIcon: SettingsIcon,
  SettingsLucideIcon: SettingsLucideIcon,
  Share2: Share2,
  SplitIcon: Split,
  ShieldCheckIcon: ShieldCheckIcon,
  ShieldEllipsisIcon: ShieldEllipsisIcon,
  ShieldHalfIcon: ShieldHalfIcon,
  ShieldIcon: ShieldIcon,
  ShieldOffIcon: ShieldOffIcon,
  ShieldXIcon: ShieldXIcon,
  ShoppingCart: ShoppingCart,
  Shrink: Shrink,
  SlidersHorizontal: SlidersHorizontal,
  SmartphoneIcon: SmartphoneIcon,
  StarIcon: StarIcon,
  Square: Square,
  SquareArrowOutUpRightIcon: SquareArrowOutUpRightIcon,
  SquareArrowRightEnterIcon: SquareArrowRightEnterIcon,
  SquareArrowRightExitIcon: SquareArrowRightExitIcon,
  SquareArrowRightIcon: SquareArrowRightIcon,
  SquareArrowUpRightIcon: SquareArrowUpRightIcon,
  SquareAsterisk: SquareAsterisk,
  SquareCheckBig: SquareCheckBig,
  SquareCodeIcon: SquareCodeIcon,
  SquareDot: SquareDot,
  SquaresExclude: SquaresExclude,
  SquareUser: SquareUser,
  SquarePenIcon: SquarePenIcon,
  StampIcon: StampIcon,
  StatusIcon: StatusIcon,
  StickyNoteIcon: StickyNoteIcon,
  StretchHorizontalIcon: StretchHorizontalIcon,
  Table2Icon: Table2Icon,
  TabletSmartphoneIcon: TabletSmartphoneIcon,
  TagIcon: TagIcon,
  ThumbsUpIcon: ThumbsUpIcon,
  TimerOffIcon: TimerOffIcon,
  Trash2Icon: Trash2Icon,
  TrendingDownIcon: TrendingDownIcon,
  TrendingUpIcon: TrendingUpIcon,
  TriangleAlertIcon: TriangleAlertIcon,
  Truck: Truck,
  User2Icon: User2Icon,
  UserRoundCheckIcon: UserRoundCheckIcon,
  UserRoundCogIcon: UserRoundCogIcon,
  UserRoundIcon: UserRoundIcon,
  UserRoundMinusIcon: UserRoundMinusIcon,
  UserRoundPlusIcon: UserRoundPlusIcon,
  UserRoundSearchIcon: UserRoundSearchIcon,
  UserRoundXIcon: UserRoundXIcon,
  UsersRoundIcon: UsersRoundIcon,
  VideoIcon: Video,
  ViewIcon: ViewIcon,
  WaypointsIcon: WaypointsIcon,
  WorkArrangementIcon: WorkArrangementIcon,
  WrenchIcon: WrenchIcon,
  XIcon: XIcon,
  XOctagonIcon: XOctagonIcon
} as const;
export type IconName = keyof typeof IconMap;